import {
  DEFAULT_TICKET,
  ITicket,
  TICKET_SCHEMA,
  TICKETS_SCHEMA,
} from '@web/dtos';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';
import { Observable } from 'rxjs';
import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import { IListGateway, ISaveGateway } from '../gateways';

export class TicketGateway
  implements
    IListGateway<number, IApiResponse<ITicket[]>>,
    ISaveGateway<ITicket, IApiResponse<ITicket>>
{
  private readonly restCallBuilder: RestCallBuilder<ITicket> =
    new RestCallBuilder<ITicket>(DEFAULT_TICKET);
  private readonly listRestCallBuilder: RestCallBuilder<ITicket[]> =
    new RestCallBuilder<ITicket[]>([]);

  list(serviceAreaId: number): Observable<IApiResponse<ITicket[]>> {
    return this.listRestCallBuilder
      .get('/tickets/', { serviceAreaId })
      .validate(API_RESPONSE_SCHEMA(TICKETS_SCHEMA), 'Ticket.list')
      .handleMessages()
      .build();
  }

  save(query: ITicket): Observable<IApiResponse<ITicket>> {
    return this.restCallBuilder
      .post('/tickets/', query)
      .validate(API_RESPONSE_SCHEMA(TICKET_SCHEMA), 'Ticket.save')
      .handleMessages()
      .build();
  }

  saveAll(query: ITicket[]): Observable<IApiResponse<ITicket[]>> {
    return this.listRestCallBuilder
      .post('/tickets/saveAll/', query)
      .validate(API_RESPONSE_SCHEMA(TICKETS_SCHEMA), 'Ticket.saveAll')
      .handleMessages()
      .build();
  }
}
